document.addEventListener("DOMContentLoaded", () => {


    /* =====================================
       MEGAMENU
    ===================================== */

    const items = document.querySelectorAll(".br-nav__item");

    items.forEach(item => {

        let closeTimer;


        /* ================================
           ENTRAR AL ITEM
        ================================= */

        item.addEventListener("mouseenter", () => {

            clearTimeout(closeTimer);

            item.classList.add("is-open");

        });


        /* ================================
           SALIR DEL ITEM
        ================================= */

        item.addEventListener("mouseleave", () => {

            clearTimeout(closeTimer);

            closeTimer = setTimeout(() => {

                item.classList.remove("is-open");

            }, 300);

        });

    });


    /* =====================================
       TODOS LOS QUIZZES
    ===================================== */

    const quizzes = document.querySelectorAll(".br-quiz");

    quizzes.forEach(quizElement => {


        /* =====================================
           DETECTAR TIPO DE QUIZ
        ===================================== */

        const isComedores =
            quizElement.closest(".br-comedores__quiz") !== null;

        const isRecamaras =
            quizElement.closest(".br-recamaras__quiz") !== null;

        const isColchones =
            quizElement.closest(".br-colchones__quiz") !== null;


        /* =====================================
           ESTADO DEL QUIZ
        ===================================== */

        let quiz;


        /* =====================================
           COLCHONES
        ===================================== */

        if (isColchones) {

            quiz = {

                tipo_colchon: null,

                tamano_colchon: null,

                presupuesto: 25000

            };

        }


        /* =====================================
           RECÁMARAS
        ===================================== */

        else if (isRecamaras) {

            quiz = {

                tamano_cama: null,

                almacenamiento: null,

                estilo_recamara: null,

                presupuesto: 25000

            };

        }


        /* =====================================
           COMEDORES
        ===================================== */

        else if (isComedores) {

            quiz = {

                capacidad_comedor: null,

                estilo_comedor: null,

                material_comedor: null,

                presupuesto: 25000

            };

        }


        /* =====================================
           SALAS
        ===================================== */

        else {

            quiz = {

                personas: null,

                color: null,

                caracteristica: null,

                presupuesto: 25000

            };

        }


        /* =====================================
           BOTÓN
        ===================================== */

        const button =
            quizElement.querySelector(".br-quiz__button");


        /* =====================================
           ACTUALIZAR BOTÓN
        ===================================== */

        function updateButton() {

            if (!button) return;

            let ready = false;


            /* COLCHONES */

            if (isColchones) {

                ready =
                    quiz.tipo_colchon &&
                    quiz.tamano_colchon;

            }


            /* RECÁMARAS */

            else if (isRecamaras) {

                ready =
                    quiz.tamano_cama &&
                    quiz.almacenamiento &&
                    quiz.estilo_recamara;

            }


            /* COMEDORES */

            else if (isComedores) {

                ready =
                    quiz.capacidad_comedor &&
                    quiz.estilo_comedor &&
                    quiz.material_comedor;

            }


            /* SALAS */

            else {

                ready =
                    quiz.personas &&
                    quiz.color &&
                    quiz.caracteristica;

            }


            button.classList.toggle(
                "is-enabled",
                Boolean(ready)
            );

        }


        /* =====================================
           CHIPS
        ===================================== */

        quizElement
            .querySelectorAll(".br-quiz__options")
            .forEach(group => {

                const groupName =
                    group.dataset.group;

                group
                    .querySelectorAll(".br-quiz__chip")
                    .forEach(chip => {

                        chip.addEventListener("click", () => {


                            /* Quitar selección anterior */

                            group
                                .querySelectorAll(".br-quiz__chip")
                                .forEach(c => {

                                    c.classList.remove(
                                        "is-active"
                                    );

                                });


                            /* Activar selección */

                            chip.classList.add(
                                "is-active"
                            );


                            /* Guardar selección */

                            quiz[groupName] =
                                chip.dataset.value;


                            /* Revisar botón */

                            updateButton();

                        });

                    });

            });


        /* =====================================
           RANGE
           TODAS LAS CATEGORÍAS
        ===================================== */

        const range =
            quizElement.querySelector(
                ".br-quiz__range"
            );

        const currentPrice =
            quizElement.querySelector(
                ".br-quiz__current-price"
            );


        if (
            range &&
            currentPrice
        ) {

            const updatePrice = () => {

                quiz.presupuesto =
                    Number(range.value);


                currentPrice.textContent =
                    "$" +
                    quiz.presupuesto.toLocaleString(
                        "es-MX"
                    );

            };


            updatePrice();


            range.addEventListener(
                "input",
                updatePrice
            );

        }


        /* =====================================
           CLICK BOTÓN
        ===================================== */

        if (button) {

            button.addEventListener("click", () => {

                if (
                    !button.classList.contains(
                        "is-enabled"
                    )
                ) return;


                /* =====================================
                   EVITAR DOBLE CLIC
                ===================================== */

                button.classList.add(
                    "is-loading"
                );

                button.disabled = true;


                /* =====================================
                   TEXTO LOADING
                ===================================== */

                let loadingText;


                if (isColchones) {

                    loadingText =
                        "Buscando tu colchón ideal";

                }


                else if (isRecamaras) {

                    loadingText =
                        "Buscando tu recámara ideal";

                }


                else if (isComedores) {

                    loadingText =
                        "Buscando tu comedor ideal";

                }


                else {

                    loadingText =
                        "Buscando tu sala ideal";

                }


                button.innerHTML = `
                    <svg
                        class="br-quiz__search-icon"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >

                        <circle
                            cx="11"
                            cy="11"
                            r="6.5"
                        ></circle>

                        <line
                            x1="16"
                            y1="16"
                            x2="21"
                            y2="21"
                        ></line>

                    </svg>

                    <span
                        class="br-quiz__loading-text"
                    >

                        ${loadingText}

                        <span
                            class="br-quiz__dots"
                        ></span>

                    </span>
                `;


                /* =====================================
                   PARÁMETROS
                ===================================== */

                const params =
                    new URLSearchParams();


                /* =====================================
                   COLCHONES
                ===================================== */

                if (isColchones) {

                    /* TIPO DE COLCHÓN */

                    params.set(
                        "filter.p.m.custom.tipo_colchon",
                        quiz.tipo_colchon
                    );


                    /* TAMAÑO */

                    params.set(
                        "br_tamano",
                        quiz.tamano_colchon
                    );


                    /* PRESUPUESTO */

                    params.set(
                        "filter.v.price.lte",
                        quiz.presupuesto
                    );


                    /* REDIRECCIÓN */

                    setTimeout(() => {

                        window.location.href =
                            `/collections/colchones?${params.toString()}`;

                    }, 500);


                    return;

                }


                /* =====================================
                   RECÁMARAS
                ===================================== */

                if (isRecamaras) {

                    /* TAMAÑO DE CAMA */

                    params.set(
                        "filter.p.m.custom.tamano_cama",
                        quiz.tamano_cama
                    );


                    /* ALMACENAMIENTO */

                    params.set(
                        "filter.p.m.custom.almacenamiento",
                        quiz.almacenamiento
                    );


                    /* ESTILO
                       NO FILTRA
                    */


                    /* PRESUPUESTO */

                    params.set(
                        "filter.v.price.lte",
                        quiz.presupuesto
                    );


                    /* REDIRECCIÓN */

                    setTimeout(() => {

                        window.location.href =
                            `/collections/recamaras?${params.toString()}`;

                    }, 500);


                    return;

                }


                /* =====================================
                   COMEDORES
                ===================================== */

                if (isComedores) {

                    /* CAPACIDAD */

                    params.set(
                        "filter.p.m.custom.capacidad_comedor",
                        quiz.capacidad_comedor
                    );


                    /* ESTILO
                       NO FILTRA
                    */


                    /* MATERIAL */

                    if (
                        quiz.material_comedor !==
                        "no-importa"
                    ) {

                        params.set(
                            "filter.p.m.custom.material_comedor",
                            quiz.material_comedor
                        );

                    }


                    /* PRESUPUESTO */

                    params.set(
                        "filter.v.price.lte",
                        quiz.presupuesto
                    );


                    /* REDIRECCIÓN */

                    setTimeout(() => {

                        window.location.href =
                            `/collections/comedores?${params.toString()}`;

                    }, 500);


                    return;

                }


                /* =====================================
                   SALAS
                ===================================== */

                /* CAPACIDAD */

                params.set(
                    "filter.p.m.custom.capacidad",
                    quiz.personas
                );


                /* COLOR */

                params.set(
                    "filter.p.m.custom.color",
                    quiz.color
                );


                /* CARACTERÍSTICA
                   RECLINABLE / ESTACIONAL
                   AMBAS FILTRAN
                */

                params.set(
                    "filter.p.m.custom.caracteristica",
                    quiz.caracteristica
                );


                /* PRESUPUESTO */

                params.set(
                    "filter.v.price.lte",
                    quiz.presupuesto
                );


                /* REDIRECCIÓN */

                setTimeout(() => {

                    window.location.href =
                        `/collections/salas?${params.toString()}`;

                }, 500);

            });

        }


        /* =====================================
           ESTADO INICIAL
        ===================================== */

        updateButton();

    });

});